import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";
export const RelativeTimeLabel = styled.span`
  display: block;

  color: ${color("text-medium")};
  font-size: 0.875rem;
  font-weight: 400;

  margin-top: 1.5rem;
`;
